import React, { Component, useEffect, useState, useRef } from "react";
import Dialog from "@material-ui/core/Dialog";
import InviteToEcosystem from "./InviteToEcosystem";
import StyledButton from "../../../common/models/Button";
import EcosystemTable from "../ecosystems/ecosystemTable";
import {
  Typography,
  Grid,
  Button,
  Box,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Paper,
  IconButton,
  Table,
  TextField,
  MenuItem,
  InputAdornment,
  Tooltip,
  FormControl,
  Select,
  Checkbox,
} from "@material-ui/core";
import {
  Add,
  ArrowDropDown,
  ChevronLeft,
  ChevronRight,
  Clear,
  Edit,
  Refresh,
  Visibility,
} from "@material-ui/icons";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CreateNewNetworkPopup from "./createNewNetworkPopup";
import SearchIcon from "@material-ui/icons/Search";

//import GA
import { trackEvent } from "../../../../tracking/index";
import CreateNewEcosystemScreen from "./CreateNewEcosystemScreen";
// import { Table } from 'react-virtualized';
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../common/helperFunctions/usePrevious";
import { FETCH_ALL_SPONSOR_NETWORKS_LOADING } from "../../../../containers/actions/types";
import { fetchAllSponsorNetworks, saveNetworkConfigurationProgress } from "../../../../containers/actions/netwrokActions";
import UpdateScreen from "./UpdateScreen";
import ViewScreen from "./ViewScreen";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import axios from "axios";
import { smlUrl } from "../../../../utils/config";
import './ecosystem.css';

const useStyles = makeStyles((theme) => ({
  alignButton: {
    textAlign: "end",
    [theme.breakpoints.down("xs")]: {
      textAlign: "start",
      marginTop: "1rem",
    },
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 0",
    marginTop: "1rem",
    borderTop: "1px solid rgba(224, 224, 224, 0.5)",
  },
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C,#173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "16px",
    paddingRight: "16px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
}));

const Ecosystems = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openInvite, setOpenInvite] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [existingSponsorFlow, setExistingSponsorFlow] = useState(false);
  const [ecosystemsData, setEcosystemsData] = useState([]);
  const [searchField, setSearchField] = useState("all");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [lastSyncTime, setLastSyncTime] = useState(new Date());
  const [selectedSponsorDetails, setSelectedSponsorDetails] = useState({
    organizationId: null,
    ecosystemId: null,
  });
  const [createNewEcosystem, setCreateNewEcosystem] = useState(false);
  const [isNetworkTypesLoaded, setIsNetworkTypesLoaded] = useState(false);

  const [updateScreen, setUpdateScreen] = useState(false);
  const [viewScreen, setViewScreen] = useState(false);
  const [rowData, setRowData] = useState({});

  const [networkTypes, setNetworkTypes] = useState([]);
  const [statusFilter, setStatusFilter] = useState("All"); // Default value for Status
  const [networkTypeFilter, setNetworkTypeFilter] = useState([]); // Default value for Network Type

  const [allSponsors, setAllSponsors] = useState([]); // Holds all unique sponsors from initial data
  const initialSponsorsSet = useRef(false); // Track if initial sponsors have been set

  let fetchEcosystemsData = useSelector(
    (state) => state?.network?.sponsorNetwork || []
  );

  let fetchEcosystemLoading = useSelector(
    (state) => state?.network?.sponsorNetworkLoading
  );

  const handleOpenViewScreen = (row) => {
    setRowData(row);
    setViewScreen(true);
  };

  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleCloseViewScreen = () => {
    setViewScreen(false);
  };

  const handleOpenUpdateScreen = (row) => {
    setRowData(row);
    setUpdateScreen(true);
  };

  const handleCloseUpdateScreen = () => {
    setUpdateScreen(false);
  };

    let saveNetwork = useSelector(
      (state) => state?.network?.saveNetworkConfiguration
    );

  const handleClearFilters = () => {
    // Reset all filters to their default values
    setSearchField("all");
    setSearchValue("");
    setStatusFilter("All");
    setNetworkTypeFilter([]); // Reset to an empty array for multiple selection

    // Dispatch the fetch API with default parameters
    dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: "",
        statusFilter: "All",
        networkTypeIDFilter: [], // Pass an empty array for networkTypeIDFilter
      })
    );
  };

  const fetchNetworkTypes = async () => {
    try {
      const res = await axios.get(`${smlUrl}/admin/fetchNetworkTypes/0`);
      if (Array.isArray(res.data.NetworkTypes)) {
        setNetworkTypes(res.data.NetworkTypes); // Store the fetched network types
      } else {
        console.error("Unexpected response format:", res.data);
        setNetworkTypes([]); // Fallback to an empty array
      }
    } catch (err) {
      console.error("Error fetching network types:", err);
      setNetworkTypes([]); // Fallback to an empty array in case of error
    }
  };

  const handleNetworkTypeDropdownOpen = () => {
    fetchNetworkTypes();
    setPage(0); // Fetch network types only if not already loaded
  };

  const handleNetworkTypeChange = (event) => {
    const selectedNetworkType = event.target.value; // Get the selected network type (ID or "All")
    setPage(0);
    // If "All" is selected, reset the filter
    if (selectedNetworkType === "All") {
      setNetworkTypeFilter([]); // Reset to an empty array
    } else {
      setNetworkTypeFilter([selectedNetworkType]); // Update with the selected ID
    }

    // Dispatch the fetch API with the updated networkTypeIDFilter
    dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: searchValue, // Use the current searchValue
        statusFilter, // Use the current statusFilter
        networkTypeIDFilter:
          selectedNetworkType === "All" ? [] : [selectedNetworkType], // Pass the selected ID or an empty array
      })
    );
  };
  const handleSearchField = (event) => {
    setSearchField(event.target.value);
    setSearchValue("");
  };

  const handleSearchValueChange = (event, value) => {
    if (typeof value === "object") {
      setSearchValue(value?.sponsorName || ""); // Update searchValue with the selected sponsor name
    } else {
      setSearchValue(event.target.value); // Update searchValue with the typed value
    }
  };

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value); // Update statusFilter

    // Ensure networkTypeFilter contains IDs
    const selectedIds = networkTypeFilter.map((type) => {
      const networkType = networkTypes.find(
        (network) =>
          network.networkType === type || network.ecosystem_type_id === type
      );
      return networkType?.ecosystem_type_id || type;
    });

    // Trigger the API call with the updated statusFilter and networkTypeFilter as IDs
    dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: searchValue,
        statusFilter: event.target.value,
        networkTypeIDFilter: selectedIds, // Ensure IDs are sent
      })
    );
  };
  const handleSearch = () => {
    // Trigger the API call with the current searchValue and filters
    setPage(0);
    dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: searchValue,
        statusFilter,
        networkTypeIDFilter: networkTypeFilter,
      })
    );
  };

  const handleRefresh = () => {
    // Trigger the API call to refresh data
    dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: searchValue,
        statusFilter,
        networkTypeIDFilter: networkTypeFilter,
      })
    );
  };

  useEffect(() => {
    dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: "",
        statusFilter: "All",
        networkTypeIDFilter: "All",
      })
    );
  }, []);

  useEffect(() => {
    if (
      fetchEcosystemsData?.SponsorNetworks &&
      fetchEcosystemsData?.SponsorNetworks.length > 0
    ) {
      setEcosystemsData(fetchEcosystemsData?.SponsorNetworks);
      // Only set allSponsors on the first load
      if (!initialSponsorsSet.current) {
        setAllSponsors(
          Array.from(
            new Set(fetchEcosystemsData.SponsorNetworks.map((item) => item.sponsorName))
          ).map((name) => ({ sponsorName: name }))
        );
        initialSponsorsSet.current = true;
      }
    }
  }, [fetchEcosystemsData]);

  const uniqueSponsors = Array.from(
    new Set(ecosystemsData.map((item) => item.sponsorName))
  ).map((name) => ({ sponsorName: name }));

  const handleOpenInvite = () => {
    trackEvent("Admin Settings", "Invite CMS", "Ecosystems");
    setOpenInvite(true);
  };

  const handleCloseInvite = () => {
    setOpenInvite(false);
  };

  const [isEditMode, setIsEditMode] = useState(false);

  const handleOpenDialog = () => {
    setIsEditMode(false);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleOpenCreateNewEcosystemScreen = (row) => {
    setRowData(row);
    setOpenDialog(false);
    setCreateNewEcosystem(true);
  };

  const handleCloseCreateNewEcosystemScreen = () => {
    setCreateNewEcosystem(false);
    setExistingSponsorFlow(false);
    setPage(0);

   dispatch({
      type: FETCH_ALL_SPONSOR_NETWORKS_LOADING,
      payload: true,
    });

    dispatch(
      fetchAllSponsorNetworks({
        searchString: "",
        statusFilter: "All",
        networkTypeIDFilter: [], // Pass an empty array for networkTypeIDFilter
      })
    );
  };

  const handleChangeExistingSponsorFlow = (value) => {
    setExistingSponsorFlow(value);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };

  const paginatedData = ecosystemsData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const showPagination =
    fetchEcosystemsData &&
    Array.isArray(fetchEcosystemsData.SponsorNetworks) &&
    fetchEcosystemsData.SponsorNetworks.length > 0;
  return (
    <Box paddingLeft={2} paddingRight={2}>
      <Box>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="h5"
              style={{ fontWeight: 500, fontSize: "2rem", marginTop: "0.5rem" }}
            >
              Network List
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between", // Ensures one element is on the left and the other on the right
            width: "100%",
            marginTop: "1rem",
          }}
        >
          <Box
            className="ecosystem-search-by-sponsor"
            style={{
              width: "30rem",
              display: "flex",
              alignItems: "center",
              position: "relative", // Ensure proper alignment of the search icon
            }}
          >
            <TextField
              size="small"
              select
              value={searchField}
              onChange={handleSearchField} // Update searchField
              variant="outlined"
              style={{
                minWidth: 220,
                backgroundColor: "#F0F0F0",
              }}
            >
              <MenuItem value="all">Select Search By</MenuItem>
              <MenuItem value="Sponsor">Sponsor</MenuItem>
            </TextField>
            {/* Always show Autocomplete, but disable if not Sponsor */}
            <Autocomplete
              size="small"
              options={allSponsors}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.sponsorName || ""
              }
              filterOptions={(options, { inputValue }) =>
                options.filter(option =>
                  (option.sponsorName || "")
                    .toLowerCase()
                    .includes(inputValue.toLowerCase())
                )
              }
              inputValue={searchValue}
              onInputChange={(event, newInputValue) => {
                setSearchValue(newInputValue);
              }}
              value={selectedSponsor}
              onChange={(event, value) => {
                setSelectedSponsor(value);
                setSearchValue(value ? value.sponsorName : "");
              }}
              disabled={searchField !== "Sponsor"}
              open={dropdownOpen}
              onOpen={() => setDropdownOpen(true)}
              onClose={() => setDropdownOpen(false)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Search"
                  style={{
                    width: "300px",
                  }}
// onInput={(e) => {
//   e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s-_]/g, "");
// }}
onInput={(e) => {
  e.target.value = e.target.value
    .replace(/[^a-zA-Z0-9\s\-.,\/()&:]/g, '') // allow only valid chars
    .slice(0, 100); // max 30 characters
}}

                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        style={{
                          marginRight: "0px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {!searchValue ? (
                          <IconButton size="small" style={{ color: "dimgray" }} onClick={() => setDropdownOpen(true)} disabled={searchField !== "Sponsor"}>
                            <ArrowDropDown />
                          </IconButton>
                        ) : (
                          <Tooltip title="Clear search" aria-label="clear">
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setSearchValue("");
                                setSelectedSponsor(null);
                              }}
                              style={{
                                cursor: "pointer",
                                color: "dimgray",
                                marginRight: "8px",
                              }}
                            />
                          </Tooltip>
                        )}
                        <IconButton
                          size="small"
                          style={{
                            backgroundColor: "#EB5E28",
                            color: "white",
                            borderRadius: "0",
                            padding: "8px",
                            marginRight: "-65px",
                          }}
                          onClick={handleSearch}
                          disabled={searchField !== "Sponsor"}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Box>

          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              startIcon={<Add />}
              style={{ borderRadius: "20px" }}
              onClick={handleOpenDialog}
              className={classes.blueButton}
            >
              Create New Network
            </Button>
          </Box>
        </Grid>

        <Dialog fullScreen open={openInvite} onClose={handleCloseInvite}>
          <InviteToEcosystem handleClose={handleCloseInvite} />
        </Dialog>
        <Grid
          container
          spacing={1}
          alignItems="center"
          style={{
            marginBottom: 16,
            marginTop: 18,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Grid
            style={{
              display: "flex",
              gap: 15,
            }}
            item
          >
            {/* Reason Code Group Type */}
            <Grid item sm="auto">
              <Box display="flex" flexDirection="column">
                <Typography style={{ fontWeight: "bold", marginBottom: 4 }}>
                  Network Type:
                </Typography>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: "200px" }}
                >
                  <Select
                    value={
                      networkTypeFilter.length > 0
                        ? networkTypeFilter[0]
                        : "All"
                    } // Bind to the first ID or "All"
                    onChange={handleNetworkTypeChange} // Update the state on selection
                    onOpen={handleNetworkTypeDropdownOpen} // Fetch network types when dropdown is opened
                  >
                    <MenuItem value="All">All</MenuItem> {/* Default option */}
                    {networkTypes.map((type) => (
                      <MenuItem
                        key={type.ecosystem_type_id}
                        value={type.ecosystem_type_id}
                      >
                        {type.networkType}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {/* Reason Code Type */}

            {/* Status */}
            <Grid item sm="auto">
              <Box display="flex" flexDirection="column">
                <Typography style={{ fontWeight: "bold", marginBottom: 4 }}>
                  Status:
                </Typography>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: "150px" }}
                >
                  <Select
                    value={statusFilter} // Bind the dropdown to the statusFilter state
                    onChange={handleStatusChange} // Trigger API call on selection
                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {/* Save Filters Button */}
            <Grid item sm="auto">
              <Button
                variant="contained"
                color="primary"
                className={classes.search}
                style={{
                  borderRadius: "2rem",
                  textTransform: "none",
                  marginTop: 28,
                  whiteSpace: "nowrap",
                }}
                onClick={handleSearch} // Trigger the search API call
                disabled
              >
                Save filters
              </Button>
            </Grid>

            {/* Clear All Filters */}
            <Grid item xs="auto" style={{ marginTop: 32 }}>
              <Typography
                variant="caption"
                style={{
                  fontSize: 14,
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  marginLeft: 10,
                }}
                onClick={handleClearFilters} // Call the clear filters function
              >
                Clear all filters
              </Typography>
            </Grid>
          </Grid>

          <Grid item>
            <Grid
              container
              direction="column"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "end",
              }}
            >
              <Grid
                item
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Typography
                  variant="body2"
                  style={{ color: "gray", marginRight: "8px" }}
                >
                  {`Last synced @ ${moment(lastSyncTime).format(
                    "HH:mm:ss; DD MMMM YYYY"
                  )}`}
                </Typography>
                <Grid>
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{
                      textDecoration: "underline",
                      fontStyle: "italic",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={handleRefresh}
                  >
                    Refresh
                    <Refresh color="primary" fontSize="small" />
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginTop: "10px",
                  width: "100%",
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginRight: "4px",
                    whiteSpace: "nowrap",
                  }}
                >
                  PER PAGE
                </Typography>
                <FormControl variant="outlined" size="small">
                  <Select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <TableContainer component={Paper}>
          <Table style={{ minWidth: 650 }}>
            {/* Table Header */}
            <TableHead style={{ backgroundColor: "#F9F9FC" }}>
              <TableRow>
                <TableCell>Sponsor</TableCell>
                <TableCell>Short Form</TableCell>
                <TableCell>Organization Code</TableCell>
                <TableCell />
                <TableCell>Network Type</TableCell>
                <TableCell>Network Type ID</TableCell>
                <TableCell />
                <TableCell>Network URL</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>

            {/* Conditional Rendering for Table Body */}
            <TableBody>
              {fetchEcosystemLoading ? (
                // Show a loading spinner while data is being fetched
                <TableRow style={{ height: 150 }}>
                  <TableCell colSpan={10} align="center">
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </TableCell>
                </TableRow>
              ) : !fetchEcosystemsData?.SponsorNetworks ||
                fetchEcosystemsData.SponsorNetworks.length === 0 ? (
                // Show "No Records Found" when the response is an empty array
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    {"No Records Found"}
                  </TableCell>
                </TableRow>
              ) : (
                // Render the table rows when there is data
                paginatedData.map((row, index) => (
                  <TableRow
                    key={index}
                    style={
                      index % 2 !== 0 ? { backgroundColor: "#F9F9FC" } : {}
                    }
                  >
                    <TableCell>{row?.sponsorName || "NA"}</TableCell>
                    <TableCell>{row?.sponsorShortFormName || "NA"}</TableCell>
                    <TableCell>{row?.organizationCode || "NA"}</TableCell>
                    <TableCell />
                    <TableCell>{row?.networkType || "NA"}</TableCell>
                    <TableCell>{row?.networkTypeID || "NA"}</TableCell>
                    <TableCell />
                    <TableCell>
                      <Typography>{row?.networkURL || "NA"}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography
                        style={{
                          backgroundColor:
                            row.status === "Active" ? "#4CAF50" : "#f44336",
                          color: "white",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          display: "inline-block",
                          minWidth: "64px",
                          textAlign: "center",
                        }}
                      >
                        {row.status}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Box
                          className={classes.iconBox}
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            marginRight: "4px",
                          }}
                        >
                          <IconButton
                            onClick={() => handleOpenViewScreen(row)}
                            style={{ padding: "4px" }}
                          >
                            <Visibility />
                          </IconButton>
                        </Box>
                        <Box
                          className={classes.iconBox}
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                          }}
                        >
                          <IconButton
                            onClick={() => {
                              if (row.status === "Pending") {
                                handleOpenCreateNewEcosystemScreen(row);
                                setIsEditMode(true);
                              } else {
                                handleOpenUpdateScreen(row);
                              }
                            }}
                            
                            style={{ padding: "4px" }}
                          >
                            <Edit />
                          </IconButton>
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination Below the Table */}
        {showPagination && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginTop={2} // Add spacing between table and pagination
          >
            {/* Left Arrow */}
            <IconButton
              size="small"
              onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
              disabled={page === 0}
            >
              <ChevronLeft fontSize="small" />
            </IconButton>

            {/* Page Info in Center */}
            <Typography variant="body2" style={{ margin: "0 8px" }}>
              {`${page + 1} out of ${Math.ceil(
                ecosystemsData.length / rowsPerPage
              )} Pages`}
            </Typography>

            {/* Right Arrow */}
            <IconButton
              size="small"
              onClick={() =>
                setPage((prev) =>
                  prev + 1 < Math.ceil(ecosystemsData.length / rowsPerPage)
                    ? prev + 1
                    : prev
                )
              }
              disabled={
                page + 1 >= Math.ceil(ecosystemsData.length / rowsPerPage)
              }
            >
              <ChevronRight fontSize="small" />
            </IconButton>
          </Box>
        )}
      </Box>

      {openDialog && (
        <CreateNewNetworkPopup
          open={openDialog}
          onClose={handleCloseDialog}
          handleOpenCreateNewEcosystemScreen={
            handleOpenCreateNewEcosystemScreen
          }
          existingSponsorFlow={existingSponsorFlow}
          handleChangeExistingSponsorFlow={handleChangeExistingSponsorFlow}
          selectedSponsorDetails={selectedSponsorDetails}
          setSelectedSponsorDetails={setSelectedSponsorDetails}
        />
      )}

      {createNewEcosystem && (
        <CreateNewEcosystemScreen
          openDialog={createNewEcosystem}
          handleCloseCreateNewEcosystemScreen={
            handleCloseCreateNewEcosystemScreen
          }
          rowData={rowData}
          isEditMode={isEditMode}
          existingSponsorFlow={existingSponsorFlow}
          selectedSponsorDetails={selectedSponsorDetails}
        />
      )}

      {viewScreen && (
        <ViewScreen
          openDialog={viewScreen}
          rowData={rowData}
          handleCloseViewScreen={handleCloseViewScreen}
        />
      )}
      {updateScreen && (
        <UpdateScreen
          openDialog={updateScreen}
          rowData={rowData}
          handleCloseUpdateScreen={handleCloseUpdateScreen}
        />
      )}
    </Box>
  );
};

export default Ecosystems;

{
  /* <Grid item xs={12} sm={6} md={6}>
<Box display="flex" justifyContent="flex-end">
  <Button
    variant="contained"
    startIcon={<Add />}
    style={{ borderRadius: "20px" }}
    onClick={handleOpenDialog}
    className={classes.blueButton}
  >
    Create New Ecosystem
  </Button>
</Box>
</Grid>
<Dialog fullScreen open={openInvite} onClose={this.handleClose}>
   <CreateNewNetworkPopup handleClose={this.handleClose} />
</Dialog> */
}
